import { ContainerBloco, TituloBloco } from "../Common/styles";
import { Container } from "./styles";
import { Clock } from "lucide-react";
import { comum } from "../../../styles/Themes/light";
import { IItemHistorico } from "./types";
import ItemHistorico from "./ItemHistorico";
import SkeletonItemHistorico from "./ItemHistorico/SkeletonItemHistorico/index";
import HistoricoVazio from "./HistoricoVazio/index";
import HistoricoErro from "./HistoricoErro/index";
import { useEffect, useState, useCallback } from "react";
import api from "../../../services/api";
import { getActionText } from "../../../utility/actionTextMapper";

interface AbaHistoricoProps {
    abaAtiva: string;
    id?: number;
    loading?: boolean;
    onNavigateToFile?: (fileId: number) => void;
    fusoHorario?: string;
}

export default function AbaHistorico({ abaAtiva, id, loading: loadingParent, onNavigateToFile, fusoHorario }: AbaHistoricoProps) {
    const [historico, setHistorico] = useState<IItemHistorico[]>([]);
    const [loading, setLoading] = useState(true);
    const [erro, setErro] = useState(false);

    const carregaHistorico = useCallback(async () => {
        if (!id) {
            setLoading(false);
            setErro(false);
            return;
        }

        try {
            setLoading(true);
            setErro(false);
            const response = await api.get(`historico-proposta/${id}`);

            if (response.data.status === 'error') {
                throw new Error(response.data.message || 'Erro ao carregar histórico');
            }

            if (response.data.status === 'success') {
                const historicoData = response.data.result || [];
                
                const historicoMapeado: IItemHistorico[] = historicoData
                    .map((item: any) => ({
                        id: item.id_historico_proposta || item.id,
                        criado: item.criado || '',
                        acao: getActionText(item.acao || ''),
                        acao_original: item.acao || '',
                        nome_responsavel: item.nome_responsavel || '',
                        tipo_responsavel: item.tipo_responsavel || '',
                        justificativa: item.justificativa || '',
                        aparelho: item.dispositivo_tipo || 'desktop',
                    }))
                    .sort((a: IItemHistorico, b: IItemHistorico) => {
                        const dateA = new Date(a.criado).getTime();
                        const dateB = new Date(b.criado).getTime();
                        return dateB - dateA;
                    });

                setHistorico(historicoMapeado);
            }
        } catch (error: any) {
            console.error('Erro ao carregar histórico:', error);
            setErro(true);
            setHistorico([]);
        } finally {
            setLoading(false);
        }
    }, [id]);

    useEffect(() => {
        if (abaAtiva === 'historico') {
            carregaHistorico();
        }
    }, [abaAtiva, carregaHistorico]);

    if (abaAtiva !== 'historico') {
        return null;
    }

    return (
        <Container>
            <ContainerBloco>
                <TituloBloco>
                    <Clock size={16} color={comum.colors.primaryRed400}/>
                    Histórico da Demanda
                </TituloBloco>

                <div className="historico">
                    {(loading || loadingParent) ? (
                        [1, 2, 3, 4, 5].map((index) => (
                            <SkeletonItemHistorico key={index} lastItem={index === 5} />
                        ))
                    ) : erro ? (
                        <HistoricoErro onRetry={carregaHistorico} />
                    ) : historico.length > 0 ? (
                        historico.map((item, index) => (
                            <ItemHistorico key={item.id} item={item} lastItem={index === historico.length - 1} onNavigateToFile={onNavigateToFile} fusoHorario={fusoHorario} />
                        ))
                    ) : (
                        <HistoricoVazio />
                    )}
                </div>
            </ContainerBloco>
        </Container>
    );
}
